import template from './payroll-expense-mapping.html';
import controller from './payroll-expense-mapping.controller';

let payrollExpenseMappingComponent = {
  restrict: 'E',
  template,
  controller
};

export default payrollExpenseMappingComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/payroll-expense-mapping/payroll-expense-mapping.component.js